<button
  type="button"
  class="btn shadow back-to-top-btn"
  [ngClass]="('copilot' | ishFeature) ? 'btn-secondary' : 'btn-primary'"
  [style.display]="isVisible ? 'block' : 'none'"
  [style.bottom]="setPosition ? '90px' : ''"
  [title]="'back_to_top.title' | translate"
  (click)="jump()"
>
  <fa-icon [icon]="['fas', 'angle-up']" />
</button>
